import { FC, ReactElement } from 'react'
import classNames from 'classnames'

import { hardRefresh } from '@/helpers/tools'
import { trans } from '@/helpers/trans'
import SVG403 from '@/images/403.svg'
import SVG404 from '@/images/404.svg'
import SVG500 from '@/images/500.svg'
import { logout } from '@/redux/app/appLegacyActions'
import { useTypedDispatch } from '@/redux/store'

interface ErrorPageProps {
    errorCode: number
    fullHeight?: boolean
}

interface ErrorContent {
    image: string
    body: string
    logout?: boolean
}

const getErrorContent = (errorCode: number): ErrorContent => {
    if (errorCode === 403) {
        return { image: SVG403, body: trans('pages.errors.403'), logout: true }
    }

    if (errorCode === 404) {
        return { image: SVG404, body: trans('pages.errors.404') }
    }

    return { image: SVG500, body: trans('pages.errors.500') }
}

export const ErrorPage: FC<ErrorPageProps> = ({ errorCode, fullHeight = false }): ReactElement => {
    const dispatch = useTypedDispatch()
    const error = getErrorContent(errorCode)

    const handleButtonClick = (): void => {
        if (error.logout) {
            dispatch(logout())

            return
        }

        hardRefresh()
    }

    const className = classNames(
        'full-height-page',
        { 'full-height-page--no-nav': fullHeight },
        'bg-primary d-flex justify-content-center align-items-center',
    )

    return (
        <div className={className}>
            <div className="text-white text-center px-3">
                <img className="mb-5 w-25" src={error.image} alt="Page not found" />

                <h5 className="text-white mb-4">
                    {trans('pages.errors.oops')}
                </h5>

                <p className="mb-5">
                    {error.body}
                </p>

                <button
                    className="btn btn-orange"
                    type="button"
                    onClick={handleButtonClick}
                >
                    {error.logout ? trans('common.logout') : trans('common.refresh')}
                </button>
            </div>
        </div>
    )
}
